import _, { isArray } from "lodash";
import { v4 as uuidv4 } from 'uuid';
import { config } from '../constant';
import { callSDK, meetingSDK } from "unifiedring-sdk";
import store from "../../context/store/store";
import { chatwindowDetails, clientDomainn, UserDetails } from "../../models/model";
import { Types } from '../../context/action/action';
import { stopRecognition } from "./voiceSdkIntegration";
import {
  callFlipDetail, recordPermission, incomingCallDetail, getDirectNumber,
  getAsrBasicLang, getUserAsrLanguage
} from './callsApiService';
import { adhocXmlFraming, adhocXmlParsing, confRemoveParticipant, mergeConf_Xml_Framing } from "./adhoc";
import {
  startCallTime, startRecordTimer, endRecordTimer,
  toastInformation, max_Call_Window, frameMultiGroupCall, singleGroupCall, toastMessageCallWindow, getCurrentCallDetail, setActiveLogs, removeActiveLog, setActiveStatus, setConnectingStatus, callInitStore, accpectApiVideoInvite, frameCallProfile, dwldCallTranscript, clearCallTimer
} from "./common";
import { calldetail, closeCaptionmeetingState, conferenceDetailState, currentCallDetail } from "../../models/callModel";
import { showNotification } from "../notification";
import moment from "antd/node_modules/moment";
import { SocketChatService } from "../socketChatService";
// import { storeActiveLogs, storeLogs } from "./store_mining";
// import { group } from "console";
import { closeVideoCallRinging, enablePermission, getCookie } from "../utils";
import { getMeetingId } from "../meetingService/apiService";
import { ConsoleView } from "react-device-detect";
import { storeActiveLogs } from "./store_mining";
import { userInfo } from "../socketChatService/utils";
import { setInitial, storeAudioTranscript } from "../socketChatService/newChat";
import { closeCaption } from "../../context/reducer/closeCaption";
// import { userInfo } from "../socketChatService/utils";
// let idleTimer: any = "";
var hark = require('hark');
// let rafId=null;
// let dataArray:any=null;
// let mediaStreamSource=null;
// let audioContext:any = null;
// let analyser:any=null;
// let pitch = 0;
// let waveInterval:any;
let {
  Registration,
  MakeCall,
  EndCall,
  Mute_AudioCall,
  UnMute_AudioCall,
  CallHold,
  CallUnHold,
  CallTransfer,
  CallConference,
  CallAccept,
  RejectCall,
  AttendedTransfer,
  AdhocConference,
  Unregistration,
  MakeReInviteCall
} = callSDK.CallWebsocketClient;

export const createCallConnection = async (data: any, ip: any) => {
  let clientDomain:clientDomainn=store.getState().loginReducer.clientDomain;
  unregister();
  if (data.ext && ip) {
    console.log('***Registration Started***')
    try {
      let username = data.ext;
      let DomainName = `${data.domain_name}:5060`;
      let password = data.dp_password;
      const regexExp = /(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/gi;
      if (process.env.REACT_APP_ENV === "qastaging")
      {
      if(clientDomain.audioturnv6.includes('ddcl.worktual'))clientDomain.audioturnv6 =  clientDomain.audioturnv6.replace('ddcl.worktual', 'th.worktual');
      if(clientDomain.audioturnv4.includes('ddcl.worktual')) clientDomain.audioturnv4= clientDomain.audioturnv4.replace('ddcl.worktual', 'th.worktual')
      
      }
      console.log(clientDomain.audioturnv4,"clientDomain.audioturnv4====");
      console.log(clientDomain.audioturnv6,"clientDomain.audioturnv6==");
      
      var configuration = {
        wsServers: `wss://${clientDomain.audiosgw}:57344`,
        viaHost: ip,
        uri: username + "@" + DomainName,
        userAgentString: config().CALL_SERVER_USER_AGENT,
        traceSip: true,
        register: true,
        authorizationUser: username,
        password: password,
        turnServers: {
          urls: [regexExp.test(ip) ? clientDomain.audioturnv6 : clientDomain.audioturnv4],
          username: config().CALL_SERVER_STUN_USERNAME,
          password: config().CALL_SERVER_STUN_PASSWORD
        },
        displayName: username,
        callId: username,
        host: ip
      };

      console.log('configuration-->>>', configuration)
      let UA = await Registration(configuration);
      inviteBinding(UA);

      UA.on("accepted", function (reason: any) {
        if (reason.method === 'REGISTER') {
          storeUserAgent(UA, 'success');
          sendReInvite();
        }
      });

      callFlipDetail();
      getDirectNumber();
      recordPermission();
      // idleTimeCheck(data);
      getAsrBasicLang();
      getUserAsrLanguage();
    } catch (error) {
      toastInformation('Call setup failure', 'warning')
    }

  }


};

export const storeUserAgent = (UA: any, registration: string) => {
  store.dispatch({
    type: Types.USER_AGENT_REDUCER,
    payloads: {
      ua: UA,
      registration: registration
    }
  });
};

function inviteBinding(UA: any) {
  let isCallInProgress = false;
  UA.on("registrationFailed", function (reason: any) {
    console.log("Registration Failed***********", reason);
    storeUserAgent('', 'failed');
  });
  UA.on("message", function (e: any) {
    console.log("message calling123");
  });
  UA.on("referInviteSent", function (e: any) {
    console.log("referInviteSent calling123");
  });

  UA.on("reinvite", function (rsession: any, xml: any) {

    if (rsession !== "") {
      let useragent: any = rsession;
      let fromcaller: string = useragent.remoteIdentity.uri.user;
      let guid = uuidv4();
      CallAccept(useragent, "audio", fromcaller);
      setUpListeners(useragent, fromcaller, "audio", "IN", guid);
      store.dispatch({
        type: Types.CONFERENCE_USER_LIST,
        payloads: useragent
      });
    }
    else { adhocXmlParsing(xml); }
  });


  UA.on("invite", function (rsession: any) {
    try {
      if (window.location.pathname !== "/login") {
        let { incomingCallWindow } = store.getState().incomingCallWindow.status || false;
        let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
        let useragent: any = rsession;
        let toId: any = (useragent.request.to._displayName).toString();
        let fromId: any = (useragent.request.from._displayName).toString();
        let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
        let logExt = (loggeduser.ext).toString();
        let directNum: any = store.getState().directNumberDetail.list || [];
        let index: number = directNum.findIndex((e: any) => e.number === fromId || e.number === toId);
        let isLoginThere: boolean = (logExt === toId || logExt === fromId) || index !== -1;
        if (isCallInProgress){
          useragent.reject({ status_code: 486 });
          return false
        } 
        // else{
        if (currentCallList.length !== 2 && !incomingCallWindow && isLoginThere) {
          let meetingStatusCheck: any = getCookie("meetingStatus") ? true : false;
          console.log("meetingStatusCheck>>>>",meetingStatusCheck);
          if(!meetingStatusCheck)
         { var ringer: any = document.getElementById("ringercall");
          var promisesRing:any = ringer.play();
          if (promisesRing !== undefined) {
            promisesRing.then(() => {
              ringer.play();
            })
            .catch((error:any) => {
              ringer.play();
            });
          }}
          let medium: string = "audio";
          let bound: string = "IN";
          let guid = uuidv4();
          let fromcaller: string = useragent.remoteIdentity.uri.user;
          if (useragent.incomingRequest.message.body.includes("m=video")) { medium = "video"; }
          let contact: any = incomingCallDetail(fromcaller);
          let inviteBody: string = useragent.incomingRequest.message.data;
          let str = 'Group-Call:';
          if (inviteBody.includes(str)) {
            let newone: string = inviteBody.slice(inviteBody.indexOf(str) + str.length);
            guid = (newone.substring(0, newone.indexOf("Group-Call-Count"))).trim();
          } else {
            let newone: string = inviteBody.slice(inviteBody.indexOf('Call-ID:') + 'Call-ID:'.length);
            guid = (newone.substring(0, newone.indexOf("CSeq:"))).trim();
          }
          store.dispatch({
            type: Types.INCOMING_CALL_POPUP,
            payloads: true,
            callDetail: {
              useragent,
              medium,
              bound,
              contact,
              fromcaller,
              fromCallerName: contact['caller_id'] || fromcaller,
              guid: guid,
              isGroupCall: inviteBody.includes(str) ? true : false
            }
          });


          setUpListeners(useragent, fromcaller, medium, "IN", guid);

          let inputOptions = {
            userName: `Worktual Call`,
            message: `Incoming call from ${contact['caller_id'] || fromcaller}`,
            type: 'call',
            titleFetch:''
          };
          
          isCallInProgress = true;
          useragent.on("terminated", function(){
            isCallInProgress = false;
          })

          useragent.on("accepted", function(){
            isCallInProgress = false;
          })

          if (contact?.is_muted === 1) {
            var currentTimestamp = moment().valueOf();
            if (currentTimestamp > parseInt(contact?.mute_timestamp)) {
              showNotification(inputOptions);
            }
          }
          else { showNotification(inputOptions); }
        }
      }
        //else { rejectCall(useragent); }
      }
    // }
    catch (e: any) {
      console.log("error is", e);
    }
  });
}

export const setUpListeners = (thissession: any, callerSip: string, medium: string, bound: string, callGuid: string) => {
  try {
    //let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
    thissession.on("accepted", function (e: any) {
      console.log("accepted----------------------------11111");
      // debugger;
      let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
      const socketservice = new SocketChatService(loggeduser.sip_login_id, loggeduser.domain_id);
      console.log("callaccept calling");
      let { activeLogs,isCallTimer } = store.getState().callReducer || {};
      let activeCallDetail: any = getCurrentCallDetail();
      let recording: any = store.getState().callPermissionDetail.recordingPermission || [];
      let isOnDemand: boolean = recording['ondemand_recording'] || false;
      let isAutomaticRecord: boolean =
        recording['automatic_recording'] ? (recording['automatic_recording'].outbound && recording['automatic_recording'].is_auto_recording) : false;
      if (activeCallDetail.isGroupCall && !activeCallDetail.isGroupHost) {

        let teamInfo: any = { teamId: activeCallDetail.guid };
        socketservice.getGroup_CallInfo(teamInfo);
      }
      let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
      let index: number = -1;
      index = currentCallList.findIndex((e:calldetail) => {
       return e.bound === bound && (e.from === callerSip || e.to === callerSip)
  
    });
      if (bound !== "IN") {

        if (!currentCallList[index].switchCallId) {
          currentCallList[index].switchCallId = e.callId;
        }

        if (e !== undefined && e.toString().includes("call-connected-info")) {
          let callInfo: any = new DOMParser().parseFromString(e, "text/xml");
          let connectionStatus: string = callInfo.getElementsByTagName('call-connected-info')[0].getAttribute('callstatus');
          let type: string = callInfo.getElementsByTagName('call-connected-info')[0].getAttribute('callType');
          if (index !== -1) {
            if (connectionStatus === 'connected' && (type === 'one-one' || type === 'voicemail' || type === 'conference' || type === 'call-park')) {
              currentCallList[index].connectingStatus = type === 'voicemail' ? 'Voicemail' : 'Attended';
              type !== 'voicemail' && startCallTime(currentCallList[index].guid);
              if(isAutomaticRecord){startRecordTimer(currentCallList[index].guid)}

            }
            currentCallList[index].callType = type;
          }
        }
        else {
          if (index !== -1) {
            if (currentCallList[index].isGroupCall) {

              // if(currentCallList[index].connectingStatus === 'Connecting...' ){
              //   currentCallList[index].connectingStatus = 'Attended'

              // }
              //   else if(currentCallList[index].connectingStatus !== 'Attended' ) {
              //     currentCallList[index].connectingStatus = 'Connecting...'
              //   }
              if(!isCallTimer){
              startCallTime(currentCallList[index].guid);
              setInitial(true)}
              setConnectingStatus(currentCallList[index].guid, 'Attended')
              if (currentCallList[index].connectingStatus === 'Reconnecting...') {
                toastInformation('You rejoined the team call', 'success')
                if (currentCallList[index].defaultGrpHost) {
                  socketservice.updateGroupCallHost(currentCallList[index].guid, (loggeduser.ext).toString());
                };

              } else if (currentCallList[index].connectingStatus === 'Attended') {
                toastInformation('You joined the team call', 'success')

              }
              currentCallList[index].connectingStatus = 'Attended';

            }
            else {

              if (currentCallList[index].connectingStatus === 'Connecting...') {
                currentCallList[index].connectingStatus = 'Attended';
                activeLogs[index].connectingStatus = 'Attended';
                storeActiveLogs(activeLogs);
                //startCallTime(currentCallList[index].guid);
              }
              else {
                currentCallList[index].connectingStatus = 'Ringing';
              }


            }

          }
          
        }

        store.dispatch({
          type: Types.UPDATDE_CALL_LIST,
          payloads: currentCallList
        });

      }
      else {
        if (currentCallList[index]) {
          if (!currentCallList[index].switchCallId) {
            currentCallList[index].switchCallId = callGuid;
          }
          currentCallList[index].connectingStatus = 'Attended';
          startCallTime(currentCallList[index].guid);
          startRecordTimer(currentCallList[index].guid);
          store.dispatch({
            type: Types.UPDATDE_CALL_LIST,
            payloads: currentCallList
          });
        }
      }
    });

    thissession.on("message", function (e: any) {
      console.log("message calling123");
    });

    thissession.on("referInviteSent", function (e: any) {
      console.log("referInviteSent calling123");
    });

    thissession.on("bye", function () {
      console.log("bye calling");

      store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_SENT,
        payload: {
          isVideoRequestSent: false,
          meetingDetails: {}
        }
      })

      closeVideoCallRinging()
      var ringer: any = document.getElementById("ringercall");
      ringer.pause();
      let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];    
      
      let removeInd: number = currentCallList.findIndex((e: any) =>
      { 
        return e.guid === callGuid || e?.switchCallId === callGuid ||e?.callAgentId===callGuid
        
      });     
      if (removeInd !== -1) {
        let ua_current = currentCallList[removeInd]?.useragent || {}
        let extraHeaders_Array = ua_current?.request?.extraHeaders || [];
        let replaceHeaders = extraHeaders_Array[0] || "";
        if (replaceHeaders.includes('Replaces:') && replaceHeaders.includes(thissession.request.callId)) {
          // EndCall(thissession);
        }
        else {
          if (currentCallList[removeInd].timer) { clearInterval(currentCallList[removeInd].timer); }
          if (currentCallList[removeInd].recTimer) { clearInterval(currentCallList[removeInd].recTimer); }
          removeCurrentCall(currentCallList[removeInd].guid);
        }
      }
      // getCurrentCallDetail(bound, callerSip);

    });

    thissession.on("progress", function () {
      console.log("Calling...");
    });

    thissession.on("trackAdded", function () {
      console.log("trackAdded calling");
      let remoteVideo: any = document.getElementById("remoteVideo");
      let localVideo: any = document.getElementById("localVideo");

      let remoteStream = new MediaStream();
      var localStream = new MediaStream();
      let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
      let index: number = _.findIndex(currentCallList, { isCurrent: true });

      var pc = thissession.sessionDescriptionHandler.peerConnection; // Gets remote tracks

      if (pc.getReceivers) {
        pc.getReceivers().forEach(function (receiver: any) {
          var track = receiver.track;
          if (track) {
            remoteStream.addTrack(track);
            TrackEvents(track, "Remote");
          }
        });
        remoteVideo.srcObject = remoteStream;
        if (index !== -1) {
          currentCallList[index].remoteStream = remoteStream;
        }
      }/* else {
        remoteStream = pc.getRemoteStreams()[0];
      }*/
      if (pc.getSenders) {
        pc.getSenders().forEach(function (sender: any) {
          if (!currentCallList[index]?.isGroupCall) {
            var track = sender.track;
            if (track) {
              localStream.addTrack(sender.track);
              TrackEvents(track, "Local");
            }
          }
          else {
            setTimeout(() => {
              var track = sender.track;
              if (index !== -1 && currentCallList[index]?.localstream && track !== null) {
                currentCallList[index].localstream = track;
                localStream.addTrack(sender.track);
                TrackEvents(track, "Local");
                var speechEvents: any;
                var options = { threshold: -50 };
                speechEvents = hark(localStream, options);
                detectActiveSpeaker(speechEvents, localStream);
              }
            }, 1000);
          }

        });
        localVideo.srcObject = localStream;
        if (index !== -1) {
          currentCallList[index].localstream = localStream;
        }

      }

      store.dispatch({
        type: Types.UPDATDE_CALL_LIST,
        payloads: currentCallList
      });

    });

    thissession.on("reject", function (response: any, cause: any) {
      console.log("reject calling");

      if (cause === "Not Found") {
        console.log("user not found");
      } else if (cause === "SIP Failure Code") {
        console.log("SIP Failure Code");
      } else if (cause === "Temporarily Unavailable") {
        console.log("Temporarily Unavailable");
      } else if (cause === "Canceled") {
        console.log("Canceled");
      }
    });

    thissession.on("terminated", function (data: any, cause: any) {
      console.log("terminated calling", data);
      console.log("terminated calling cause", cause);
      localStorage.removeItem('call_number');
      if (cause === 'Unavailable') return;
      var ringer: any = document.getElementById("ringercall");
      ringer.pause();
      if (cause === 'Unavailable') return;

      if (cause === "BYE" && data.callId) {
        console.log(data,"terminated datacallid>>");      
        return disconnectCall(data.callId);
      }
      if (cause === "unable to acquire streams" && data.callId) {
        toastInformation("Unable to fetch your audio, Please check your devices");

      }
      if (bound === "IN") {
        try {
          if (cause === "Canceled") {
            /*let calldetails = {
              bound: config().CALL_LOG_MISSED,
              medium: medium,
              call_duration: "",
              from_caller: callerSip,
              to_caller: loggedUserDetails.ext.toString()
            };
            storeCalllogs(calldetails);*/
            ringer.pause();
            store.dispatch({
              type: Types.INCOMING_CALL_POPUP,
              payloads: false,
              callDetail: {}
            });
          } else {
            ringer.pause();

            let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
            let removeInd: number = currentCallList.findIndex((e: any) => e.guid === callGuid || e?.switchCallId === callGuid);


            if (removeInd !== -1) {
              let ua_current = currentCallList[removeInd]?.useragent || {}
              let extraHeaders_Array = ua_current?.request?.extraHeaders || [];
              let replaceHeaders = extraHeaders_Array[0] || "";
              if (replaceHeaders.includes('Replaces:') && replaceHeaders.includes(thissession.request.callId)) {
                // EndCall(thissession);
              }
              else {
                if (currentCallList[removeInd].timer) { clearInterval(currentCallList[removeInd].timer); }
                removeCurrentCall(currentCallList[removeInd].guid);
              }
            }
            else {
              if (thissession) {
                EndCall(thissession);
              }
              ringer.pause();
              store.dispatch({
                type: Types.INCOMING_CALL_POPUP,
                payloads: false,
                callDetail: {}
              });
            }
          }
        } catch (error) {
          console.log("error ", error);
        }
      } else {
        try {
          disconnectCall(callGuid);
          let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
          let index: number = -1;
          let conferenceDetail: conferenceDetailState = store.getState().conferenceDetails || [];
          if (conferenceDetail.isConference) {
            index = currentCallList.findIndex((e: calldetail) => (e.from === callerSip || e.to === callerSip));
          }
          else {
            index = currentCallList.findIndex((e: calldetail) => e.bound === bound
              && (e.from === callerSip || e.to === callerSip));
          }
          if (index !== -1) {
            let ua_current = currentCallList[index]?.useragent || {}
            let extraHeaders_Array = ua_current?.request?.extraHeaders || [];
            let replaceHeaders = extraHeaders_Array[0] || "";
            if (replaceHeaders.includes('Replaces:') && replaceHeaders.includes(thissession.request.callId)) {
              console.log("Mobility Calling");
            } else {
              disconnectCall(callGuid);

            }
          }
        } catch (error) {
          console.log("error", error);
        }
      }
    });

    thissession.on("failed", function (e: any, f: any) {
      console.log("failed calling e ", e);
      let { isCallActive } = store.getState().updatedCallList || false;
      if (e) {
        disconnectCall(e.callId);
      }
      else if (!isCallActive) {
        store.dispatch({
          type: Types.INCOMING_CALL_POPUP,
          payloads: false,
          callDetail: {}
        });

      }
      var ringer: any = document.getElementById("ringercall");
      ringer.pause();

      try {
        if (f === "Busy Here") {
          // let calldetails = {
          //   bound: bound === "IN" ? config().CALL_LOG_INCOMING : config().CALL_LOG_OUTGOING,
          //   medium: medium,
          //   call_duration: "",
          //   from_caller: callerSip,
          //   to_caller: loggedUserDetails.ext.toString()
          // };
          // storeCalllogs(calldetails);

        }
        else if (f === "WebRTC Error") {
          enablePermission('callpage');
          //toastInformation(config().DEVICE_ALERT, "failure");
        }
      }
      catch (error) { console.log("error", error); }
    });

    thissession.on("cancel", function (e: any) {
      console.log("cancel >>>>>>>>>>>>", e);


    });
  } catch (error) { console.log("Setup lister", error); }
};

function TrackEvents(track: any, stream: string) {
  track.onended = function (e: any) { console.log("Track Ended"); };
  track.onmute = function (e: any) { console.log("Track Muted"); };
  track.onunmute = function (e: any) { console.log("Track onunmute"); };
}
export const detectActiveSpeaker = (speechEvents: any, localStream: any) => {
  try {
    speechEvents.on('speaking', function () {
      sendAudioWave(true, 0);

    });
    speechEvents.on('stopped_speaking', function () {
      sendAudioWave(false, 0);
    })

  }
  catch (e) {
    console.log("error");
  }
};
const sendAudioWave = (status: boolean, pitch: number) => {
  let callReducer = store.getState().updatedCallList || [];
  let currentCallList: calldetail[] = callReducer.callDetails || [];
  let index = currentCallList.findIndex((e: calldetail) => (e.isGroupCall === true && e.holdState === false));
  let loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
  if (index !== -1 && currentCallList[index].guid !== "") {
    let data: any = currentCallList[index];
    let grpSpeechInfo: any = {
      TeamID: data.guid,
      user: loggedUser.ext,
      isSpeaking: status,
      audioPitch: pitch
    }
    const socketservice = new SocketChatService(userInfo()?.fromID, userInfo()?.domainId);
    socketservice.groupCallSpeechStatus(grpSpeechInfo);

  }
}

export const callnow = (sipId: string, medium: string) => {
  let returnData = { isCheck: false, error: config().SELF_USER_NUMBER };
  try {
    let { ua, registration } = store.getState().userAgentDetail;

    var floatRegex = /^((\d+(\.\d *)?)|((\d*\.)?\d+))$/;

    if (sipId !== "" && sipId !== undefined) {
      sipId = sipId.toString().trim();
      if (sipId.length > 2) {
        let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
        var strChk = sipId;
        if ((loggeduser.ext.toString() === sipId) || (sipId.includes("*")) || (sipId.includes("#"))) {
          returnData.isCheck = true;
          return returnData;
        }
        else if (sipId.includes("+")) {
          if (sipId.substring(0, 1) === "+") {
            strChk = sipId.slice(1);
            if (sipId.length < 8) {
              returnData.isCheck = true;
              return returnData;
            }
          }
          else {
            returnData.isCheck = true;
            return returnData;
          }
        }
        if ((!(/^\d+$/).test(strChk)) || (!floatRegex.test(strChk))) {
          returnData.isCheck = true;
          return returnData;
        }

        if (ua === '') {
          returnData.error = registration === 'pending' ? config().settingUp : config().TRY_AGAIN;
          returnData.isCheck = true;
          return returnData;
        }

        else if (medium === 'video') {
          returnData.error = config().FEATURE_IMP_ALTER;
          returnData.isCheck = true;
          return returnData;
        }
      }
      else {
        returnData.isCheck = true;
        return returnData;
      }
    }
    else {
      returnData.error = config().ENTER_VALID_NUMBER;
      returnData.isCheck = true;
      return returnData;
    }
    return returnData;
  }
  catch (e) {
    console.log("e is ", e);
    return returnData;
  }
};

export const initiateCall = (sipId: string, medium: string, type?: string, isquickCall?: boolean) => {
  try {
    console.log('sipId-->>', sipId)
    let callReducer = store.getState().updatedCallList || [];
    if (callReducer.callDetails.length < 2) {
      if(callReducer.callDetails.length !==0){
        let det:any=callReducer.callDetails.findIndex((elem:any)=>{
     return   elem.contact.ext === sipId.toString()
   })
   if(det > -1){
     toastInformation("You are already in call with this user");
     return;
    }}
      let callCheck: any = callnow(sipId, medium);
      if (callCheck.isCheck) {
        toastInformation(callCheck.error, "failure");
        localStorage.removeItem('call_number');
        return true;
      }
      let currentCallList: calldetail[] = callReducer.callDetails || [];


      let confInfo: conferenceDetailState = store.getState().conferenceDetails || {};
      let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
      let recording: any = store.getState().callPermissionDetail.recordingPermission || [];
      let isOnDemand: boolean = recording['ondemand_recording'] || false;
      let isAutomaticRecord: boolean =
        recording['automatic_recording'] ? (recording['automatic_recording'].outbound && recording['automatic_recording'].is_auto_recording) : false;
      //let outBoundRecrding: boolean = recording['automatic_recording'] ? recording['automatic_recording'].outbound : false;

      let contact: any = incomingCallDetail(sipId) || [];
      let guid = uuidv4();
      if (currentCallList.length !== 0) {
        if (!currentCallList[currentCallList.length - 1].holdState) { holdCall(); }
        currentCallList[currentCallList.length - 1].isCurrent = false;
      }
       //let useragent:any;
      var uri = "sip:" + sipId + "@" + loggedUserDetails.domain_name;
      let UA = store.getState().userAgentDetail.ua;
      let useragent = MakeCall(
        UA,
        uri,
        medium,
        contact['caller_id'] || "unknownUser"
      );
      setUpListeners(useragent, sipId, medium, "OUT", guid);
      let data: calldetail = {
        guid,
        useragent: useragent,
        from: (loggedUserDetails['ext']).toString(),
        to: sipId,
        muteState: false,
        holdState: false,
        recordState: isAutomaticRecord,
        onDemand: isOnDemand,
        autoRecord: isAutomaticRecord,
        medium: medium,
        bound: "OUT",
        contact,
        isCurrent: true,
        consult: (type === 'consult') ? true : false,
        isNewCall: (confInfo.isConference) ? true : false,
        isGroupCall: false,
        isGroupHost: true,
        groupCallInfo: {
          'GroupDetails': {},
          'IndividualDetails': {},
          'PSTNDetails': {}
        },
        connectingStatus: 'Dialing',
        callType: '',
        timer: 0
      };

      currentCallList.push(data);
      //startCallTime(guid);
      // if (isAutomaticRecord) { startRecordTimer(guid); }
      //let history=window.location.href||''


      callInitStore(currentCallList);

      // if (confInfo.isConference) {
      //   store.dispatch({
      //     type: Types.UPDATDE_CONFERENCE_NEWCALL,
      //     payloads: true
      //   });
      // }
      if (!window.location.href.includes('/calls')) { max_Call_Window(); }
      setActiveLogs(data);
    }
    else {
      toastInformation(`Please merge the calls before making a new call`, 'Warning')
    }
  } catch (e: any) { console.log("error is", e); }
};
export const currentCallEnd = () => {

  try {
let{transcriptLoading,transcriptEnable,autoDwld}=store.getState().closeCaption;
    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
    let index: number = currentCallList.findIndex((e: any) => e.isCurrent === true);
    if (currentCallList[index] !== undefined) {
      // removeActiveLog(currentCallList[index]);
      if (currentCallList[index].timer) { clearInterval(currentCallList[index].timer); }
      if (currentCallList[index].recTimer) { clearInterval(currentCallList[index].recTimer); }
      let useragent: any = currentCallList[index].useragent;
      removeCurrentCall(currentCallList[index].guid);
      localStorage.removeItem('call_number');
      EndCall(useragent);
      // storeAudioTranscript([],true,false);
      if(autoDwld){dwldCallTranscript();}
    }
  }
  catch (e: any) { console.log("error", e); }
};

export const sendDirectGroupVideoCallRequest=(participant:any)=>{
  try {
    let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
    let meetingDetails: any = {
      participants: "",
      // title:   'Meet now '+  moment(new Date()).format('DD MMM,YYYY HH:mm:ss A'),
      title: `Quick Meeting with ${loggedUserDetails.caller_id.charAt(0).toUpperCase() + loggedUserDetails.caller_id.slice(1)} `,
      meeting_id: getMeetingId(),
      is_host_myaudio: true,
      is_host_myvideo: true,
      is_participant_video: true,
      password: "",
      is_use_personal_meeting_id: false,
      is_participant_waiting_room: false,//videoprofileData?.security.wating_room !== undefined? videoprofileData?.security.wating_room:false,
      personal_meeting_id: getMeetingId()
    }
    let randomId = uuidv4();
    let userInfo = store.getState().loginReducer.userdetails || [];
    let partInfo: any = [{
      email: userInfo.Email,
      ext: userInfo.ext,
      name: userInfo.caller_id,
      profile_img: userInfo.profile_url,
      roletype: 1,
      sipid: (userInfo.sip_login_id)?.toString(),
      user_type: 'company'
    }]

    participant.forEach((elem:any)=>{
      if(elem.sip_login_id !== userInfo.sip_login_id){let data:any={};
      data.email= elem.email_id;
      data.ext= `${elem.ext}`;
      data.name=elem.caller_id;
      data.profile_img= elem.ImageURL;
      data.roletype=2;
      data.sipid= (elem.sip_login_id)?.toString();
      data.user_type='company'
      partInfo.push(data);}
    })

    


    meetingDetails.participants = partInfo;

    meetingDetails['meeting_id'] = randomId;

    console.log("meetingDetails >>>>>>>", meetingDetails);

    return new Promise((resolve, reject) => {
      new meetingSDK.MeetingRestService().switchtoVideomeetnow(meetingDetails).then((result: any) => {
        console.log("result >>>>>", result);
        if (result?.statusCode === 200) {

          meetingDetails.inviteUrl = result.inviteUrl;
          meetingDetails.uuid = result.uuid;
          meetingDetails.hostName = loggedUserDetails.caller_id;


          const socketservice = new SocketChatService(loggedUserDetails.sip_login_id, loggedUserDetails.domain_id);

         participant.forEach((elem:any)=>{if(elem.sip_login_id !== userInfo.sip_login_id) {let data: any = { sipId: [`${elem.sip_login_id}`], meetingDetails }
          console.log("Send video call data >>>>>", data);
          socketservice.senddirectVideoRequest(data);}})
          // let count:any=participant.filter((elem:any)=>{return elem.sip_login_id !== userInfo.sip_login_id })
          store.dispatch({
            type: Types.VIDEOCALL_RING_STATUS,
            payload: {
             ringStatus: true
            }
          })

          store.dispatch({
            type: Types.VIDEO_CALL_REQUEST_SENT,
            payload: {
              isVideoRequestSent: true,
              meetingDetails: meetingDetails
            }
          })

          store.dispatch({
            type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
            payload: {
              meetingDetails: meetingDetails,
              isVideocallRingvideo: false,
              isDirectVideocall: true
            }
          })
        }
        else {

        }
      })
        .catch((err: any) => {
          console.log("err>>***");

        });
    })

  }
  catch (error) {

  }
}

export const callEndWithGiud = (guid: string) => {

  try {


    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
    let index: number = currentCallList.findIndex((e: any) => e.guid === guid || (currentCallList[0].switchCallId));
    if (currentCallList[index] !== undefined) {
      if (currentCallList[index].timer) { clearInterval(currentCallList[index].timer); }
      if (currentCallList[index].recTimer) { clearInterval(currentCallList[index].recTimer); }
      let useragent: any = currentCallList[index].useragent;
      removeCurrentCall(currentCallList[index].guid);
      EndCall(useragent);
    }
  } catch (e: any) { console.log("error", e); }
};

const disconnectCall = (incomingGuid: string) => {
  let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];

  let index: number = currentCallList.findIndex((e: any) => { return e.guid === incomingGuid || e.switchCallId ===incomingGuid?.toString()});

  if (index !== -1) {
    if (currentCallList[index].timer) { clearInterval(currentCallList[index].timer); }
    if (currentCallList[index].recTimer) { clearInterval(currentCallList[index].recTimer); }
    removeCurrentCall(currentCallList[index].guid);
  }
};

export const removeCurrentCall = (guid: string) => {
  try {
    let closeCaption: closeCaptionmeetingState = store.getState().closeCaption || [];
    if (closeCaption.guid === guid) {
      stopRecognition(guid + "_rem");
      stopRecognition(guid + "_loc");
      store.dispatch({ type: Types.ASR_CLEAR_DATA });
    }
    //let loggedUserDetails:UserDetails = store.getState().loginReducer.userdetails || [];
    let currentCalldetail: currentCallDetail = store.getState().updatedCallList || [];
    //let conferenceDetail: conferenceDetailState = store.getState().conferenceDetails || [];
    let currentCallList: calldetail[] = currentCalldetail.callDetails || [];
    let temp:any=[...currentCallList];

    let index: number = currentCallList.findIndex((e: any) => {return e.guid === guid || e.switchCallId === guid});
    if (index !== -1) {
      removeActiveLog(currentCallList[index])
      let userAgent;
      if (currentCallList[index].isNewCall) {
        store.dispatch({
          type: Types.UPDATDE_CONFERENCE_NEWCALL,
          payloads: false
        });
      }
      userAgent = currentCallList[index].useragent;
      currentCallList.splice(index, 1);

      if (currentCallList.length !== 0) {
        let findIndex: number = currentCallList.findIndex((elem: any) => (elem.holdState === false));
        if (findIndex === -1) {
          if (currentCallList[currentCallList.length - 1].holdState === true) {
            currentCallList[currentCallList.length - 1].holdState = false;
            currentCallList[currentCallList.length - 1].isCurrent = true;
            if (currentCallList[currentCallList.length - 1].useragent) {
              CallUnHold(currentCallList[currentCallList.length - 1].useragent);
            }

          }
        }
        else{
          let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
          currentCallList[currentCallList.length -1].callduration=temp[index]?.callduration;
          currentCallList[currentCallList.length -1].recordDuration=temp[index]?.recordDuration;
          if(temp[index]?.isGroupCall && temp[index].isHostId===loggedUserDetails.ext.toString()){
            currentCallList[currentCallList.length -1].to = temp[index]?.to;
          }
        }

      }
      else {
        let conferenceDetail: conferenceDetailState = store.getState().conferenceDetails || [];
        if (conferenceDetail.isConference && !conferenceDetail.isNewCall) {
          if (userAgent) {
            EndCall(userAgent);
            EndCall(conferenceDetail.callDetails);
          }

          //conferenceDetails.callDetails.close();
          // store.dispatch({
          //   type: Types.UPDATDE_CONFERENCE_LIST,
          //   payloads: {
          //     list: [],
          //     checkConf: false,
          //     isNewCall: false
          //   }
          // });
        }
      }
      let history = window.location.href || "";

      store.dispatch({
        type: Types.CALL_END_WINDOW,
        payloads: {
          callDetails: currentCallList,
          isWindowSlide: currentCallList.length === 0 ? true : ((currentCallList.length === 2 && currentCalldetail.isCallFullScreen) ? false : currentCalldetail.isWindowSlide),
          minimizedWindow: (history.includes('calls')) ? (currentCallList.length > 1 ? true : false) : currentCalldetail.callDetails.length === 0 ? false : true,
          isCallFullScreen: (history.includes('calls')) ? (currentCallList.length === 1 ? currentCalldetail.isCallFullScreen : false) : false,
          isCallActive: currentCallList.length === 0 ? false : true,
          rightSideWindow: currentCallList.length === 0 ? 'dialpad' : currentCalldetail.isCallActive ? 'participantList' : currentCalldetail.rightSideWindow,
          centerWindow: currentCallList.length === 0 ? (currentCalldetail.leftSideWindow === 'callList') ? 'callDetail'
            : (currentCalldetail.leftSideWindow === 'voiceMail') ? 'voiceDetail'
              : 'recordDetail' : 'callWindow',
          isTranscriptionOnOff: currentCallList.length === 0 ? true : currentCalldetail.isTranscriptionOnOff
        }
      });
    }
  } catch (error: any) { console.log("error", error); }
};

export const rejectCall = (userAgent: any) => {

  var ringer: any = document.getElementById("ringercall");
  ringer.pause();
  RejectCall(userAgent);

  store.dispatch({
    type: Types.INCOMING_CALL_POPUP,
    payloads: false,
    callDetail: {}
  });
};

export const muteCall = () => {
  try {
    let conferenceDetails: any = store.getState().conferenceDetails || [];
    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
    let index: number = _.findIndex(currentCallList, { isCurrent: true });
    if (index !== -1) {

      if (!currentCallList[index].muteState) {
        if (conferenceDetails.isConference && !conferenceDetails.isNewCall) {
          Mute_AudioCall(conferenceDetails.callDetails);
        }
        else { Mute_AudioCall(currentCallList[index].useragent); }
      }
      else {
        if (conferenceDetails.isConference && !conferenceDetails.isNewCall) {
          UnMute_AudioCall(conferenceDetails.callDetails);
        }
        else { UnMute_AudioCall(currentCallList[index].useragent); }
      }

      currentCallList[index].muteState = !currentCallList[index].muteState;
      store.dispatch({
        type: Types.UPDATDE_CALL_LIST,
        payloads: currentCallList
      });
    }
    //}
  } catch (error) { console.log("error ", error); }
};

export const holdCallWithGuid = (guid: string) => {
  try {
    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
    let index: number = currentCallList.findIndex((e: any) => e.guid === guid);
    let { activeLogs } = store.getState().callReducer || {};
    let recentIndex: number = activeLogs.findIndex(
      (ele: any) => ele.guid === currentCallList[index].guid
    );
    if (currentCallList[index] !== undefined) {
      if (currentCallList[index].holdState === false) {
        let newIndex: number = _.findIndex(currentCallList, { holdState: true });
        currentCallList[index].holdState = true;
        currentCallList[index].isCurrent = false;
        CallHold(currentCallList[index].useragent);
        activeLogs[recentIndex].callStatus = 'Hold'

        if (newIndex !== -1) {
          let recentIndexNew: number = activeLogs.findIndex(
            (ele: any) => ele.guid === currentCallList[newIndex].guid
          );
          currentCallList[newIndex].holdState = false;
          currentCallList[newIndex].muteState = false;
          currentCallList[newIndex].isCurrent = true;
          CallUnHold(currentCallList[newIndex].useragent);
          activeLogs[recentIndexNew].callStatus = 'Active'
        }
      }
      else {
        let newIndex: number = _.findIndex(currentCallList, { holdState: false });

        currentCallList[index].holdState = false;
        currentCallList[index].muteState = false;
        currentCallList[index].isCurrent = true;
        CallUnHold(currentCallList[index].useragent);
        activeLogs[recentIndex].callStatus = 'Active'
        if (newIndex !== -1) {
          let recentIndexNew: number = activeLogs.findIndex(
            (ele: any) => ele.guid === currentCallList[newIndex].guid
          );
          currentCallList[newIndex].holdState = true;
          currentCallList[newIndex].isCurrent = false;
          CallHold(currentCallList[newIndex].useragent);
          activeLogs[recentIndexNew].callStatus = 'Hold'
        }
      }
      store.dispatch({
        type: Types.UPDATDE_CALL_LIST,
        payloads: currentCallList
      });
    }
  } catch (error) { console.log("error ", error); }
};
export const holdCall = () => {
  try {

    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
    let index: number = _.findIndex(currentCallList, { isCurrent: true });

    if (index !== -1) {
      let data: any = currentCallList[index];

      if (!currentCallList[index].holdState) {
        currentCallList[index].holdState = true;
        CallHold(data.useragent);
        setActiveStatus(currentCallList[index].guid, 'Hold')
      } else {
        currentCallList[index].holdState = false;
        currentCallList[index].muteState = false;
        CallUnHold(data.useragent);
        setActiveStatus(currentCallList[index].guid, 'Active')
      }

      store.dispatch({
        type: Types.UPDATDE_CALL_LIST,
        payloads: currentCallList
      });
    }
  } catch (error) { console.log("error ", error); }
};

export const sendDTMF = (val: any) => {
  try {
    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
    let index: number = _.findIndex(currentCallList, { isCurrent: true });
    if (index !== -1) { CallConference(currentCallList[index].useragent, val); }
  }
  catch (error) { console.log("error ", error); }
};

export const callTransfer = (ext: string) => {
  try {
    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
    let index: number = currentCallList.findIndex((e: calldetail) => e.isCurrent === true);
    if (index !== -1) {
      let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
      let uri = "sip:" + ext + "@" + loggedUserDetails.domain_name;
      CallHold(currentCallList[index].useragent);

      setTimeout(function () {
        CallTransfer(
          currentCallList[index].useragent,
          uri,
          currentCallList[index].medium,
          loggedUserDetails.caller_id
        );
        // setTimeout(function() {
        //   callEndWithGiud(currentCallList[index].guid);
        // }, 1000);
      }, 2000);
    }
  } catch (error) { console.log("error", error); }
};

export const attendedCallTransfer = () => {

  let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
  let index: number = currentCallList.findIndex((e: calldetail) => e.holdState === false);
  if (index !== -1) {
    let preCall: calldetail = currentCallList[index - 1];
    let current: calldetail = currentCallList[index];
    AttendedTransfer(preCall.useragent, current.useragent);
  }
};

export const swapCall = () => {
  let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
  for (let i = 0; i < currentCallList.length; i++) {
    if (currentCallList[i].holdState === false) {
      if (i === currentCallList.length - 1) {
        currentCallList[0].holdState = false;
        currentCallList[0].isCurrent = true;
        CallUnHold(currentCallList[0].useragent);
      } else {
        currentCallList[i + 1].holdState = false;
        currentCallList[i + 1].isCurrent = true;
        CallUnHold(currentCallList[i + 1].useragent);
      }

      currentCallList[i].holdState = true;
      currentCallList[i].isCurrent = false;
      CallHold(currentCallList[i].useragent);
      store.dispatch({
        type: Types.UPDATDE_CALL_LIST,
        payloads: currentCallList
      });
      break;
    }
  }
};

export const callMergeHandle: any = () => {
  let isconference: any = store.getState().conferenceDetails.isConference || false;
  let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
  if (!isconference) {
    let currentCallIndex: number = currentCallList.findIndex((e: any) => e.isCurrent === true);
    // let currentCall = currentCallList[currentCallIndex];
    // let cur_Index: number = currentCallList.findIndex((e: calldetail) => e.bound === currentCall.boud &&
    //   (e.from === currentCall.callerSip || e.to === currentCall.callerSip));
    // if (cur_Index === -1) { cur_Index = currentCallList.length - 1; }

    if (currentCallList.length > 1 && currentCallIndex !== -1) {
      let xml = adhocXmlFraming(currentCallList, currentCallIndex);
      let userData: any = currentCallList[currentCallIndex];
      // let xml = adhocXmlFraming(currentCallList, cur_Index);
      // let userData: any = currentCallList[cur_Index];
      console.log('xml<><><><><>', xml)


      AdhocConference(userData.useragent, xml);




    }
    else { toastInformation(config().ADHOC_CONF_MERGE_ALERT, "success"); }
  }
  else {

    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
    let currentCallIndex: number = currentCallList.findIndex((e: calldetail) => e.isCurrent === true);
    let current_user = currentCallList[currentCallIndex].useragent;

    let xml = mergeConf_Xml_Framing(current_user);
    console.log('xml<><><><><>2', xml)

    AdhocConference(current_user, xml);
  }
};

export const removeParticipant = (removeParticipantData: any) => {

  try {
    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
    let currentCallIndex: number = currentCallList.findIndex((e: calldetail) => e.isCurrent === true);
    let currentCall = currentCallList[currentCallIndex];
    let current_user: any = currentCall.useragent;

    let xml = confRemoveParticipant(removeParticipantData);
    AdhocConference(current_user, xml);
  }
  catch (e: any) { console.log("error is", e); }
};

export const callrecording = () => {

  let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
  let currentCallIndex: number = currentCallList.findIndex((e: calldetail) => e.isCurrent === true);

  currentCallList[currentCallIndex].recordState = !currentCallList[currentCallIndex].recordState;
  if (currentCallList[currentCallIndex].recordState) { startRecordTimer(currentCallList[currentCallIndex].guid); }
  else { endRecordTimer(currentCallList[currentCallIndex].guid); }

  store.dispatch({
    type: Types.UPDATDE_CALL_LIST,
    payloads: currentCallList
  });
};

export const unregister = () => {
  try {
    let UA: any = store.getState().userAgentDetail.ua;
    currentCallEnd();
    if (UA) {
      console.log('***Unregitration sending for the previous connection***')
      Unregistration(UA);
    }
  }
  catch (e: any) { console.log("error is", e); }
};


export const initiateGroupCall = (type: string, internalUsers: any, externalUsers?: any) => {
  try {
    let callReducer = store.getState().updatedCallList || [];
    if (callReducer.callDetails.length < 2) {
      let currentCallList: calldetail[] = callReducer.callDetails || [];
      let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
      var uri = 'TeamCall';
      let UA = store.getState().userAgentDetail.ua;
      let framed: any = {};
      let medium: any;
      let guid: string = '';
      let isHost: boolean = true;
      if (type !== 'Rejoin') {
        guid = uuidv4();
        framed = type === 'single' ? singleGroupCall(guid, internalUsers) : frameMultiGroupCall(guid, 'join', internalUsers, externalUsers);
      }
      else {
        let { groupCallInfo, groupNames } = internalUsers;
        framed.grouped = groupCallInfo || {};
        framed.grouped['GroupNames'] = groupNames;
        guid = internalUsers.guid;
        let groupArr: any = (Object.keys(groupCallInfo.GroupDetails)).map(function (x) { return x = 'con' + x });
        let { header } = frameMultiGroupCall(guid, type, (groupArr).concat(Object.keys(groupCallInfo.IndividualDetails)), Object.keys(groupCallInfo.PSTNDetails));
        framed.header = header;
        isHost = internalUsers.isHost;
      }
      let sipId: string = guid;
      let groupHeader = ['Group-Call: ' + framed.header];
      if (currentCallList.length !== 0) {
        if (!currentCallList[currentCallList.length - 1].holdState) { holdCall(); }
        currentCallList[currentCallList.length - 1].isCurrent = false;
      }
      //   let useragent:any;
      let useragent = MakeReInviteCall(
        UA,
        uri,
        medium,
        "unknownUser",
        groupHeader
      );

      setUpListeners(useragent, sipId, medium, "OUT", sipId);
      let confInfo: conferenceDetailState = store.getState().conferenceDetails || {};
      let recording: any = store.getState().callPermissionDetail.recordingPermission || [];
      let isOnDemand: boolean = recording['ondemand_recording'] || false;
      let isAutomaticRecord: boolean =
        recording['automatic_recording'] ? (recording['automatic_recording'].outbound && recording['automatic_recording'].is_auto_recording) : false;
      let contact: any = incomingCallDetail(sipId) || [];
      let data: calldetail = {
        guid,
        useragent: useragent,
        from: (loggedUserDetails['ext']).toString(),
        to: sipId,
        muteState: false,
        holdState: false,
        recordState: isAutomaticRecord,
        onDemand: isOnDemand,
        autoRecord: isAutomaticRecord,
        medium: medium,
        bound: "OUT",
        contact,
        isCurrent: true,
        consult: false,
        isNewCall: (confInfo.isConference) ? true : false,
        isGroupCall: true,
        groupCallInfo: {
          'GroupDetails': framed.grouped['GroupDetails'] || {},
          'IndividualDetails': framed.grouped['IndividualDetails'] || {},
          'PSTNDetails': framed.grouped['PSTNDetails'] || {}
        },
        groupNames: framed.grouped['GroupNames'] || {},
        isHostId: isHost ? (loggedUserDetails['ext']).toString() : internalUsers.isHostId,
        isGroupHost: isHost,
        defaultGrpHost: type === 'Rejoin' ? internalUsers.defaultGrpHost : true,
        callStatus: 'Active',
        connectingStatus: type === 'Rejoin' ? 'Reconnecting...' : 'Connecting...',
        isAudioWave: false,
        activeSpeakerName: "unkown",
        timer: 0
      };
      currentCallList.push(data);
      // startCallTime(guid)
      // if (isAutomaticRecord) { startRecordTimer(guid); }
      callInitStore(currentCallList);
      if (!window.location.href.includes('/calls')) { max_Call_Window(); }
      if ((currentCallList.length === 1) ? true : callReducer.isCallActive) {
        setActiveLogs(data, framed.header);
        if (type === 'Rejoin') {
          const socketservice = new SocketChatService(loggedUserDetails.sip_login_id, loggedUserDetails.domain_id);
          let teamInfo: any = { teamId: internalUsers.guid };
          socketservice.getGroup_CallInfo(teamInfo);
          setConnectingStatus(guid, 'Reconnecting')
        }
      }
    }
    else {
      toastInformation(`Please merge the calls before making a new call`, 'Warning')
    }

  }
  catch (e: any) { console.log("error is", e); }
}

export const sendAddParticipantToSocket = (internalUsers: any, externalUsers: any) => {
  let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];

  const socketservice = new SocketChatService(loggeduser.sip_login_id, loggeduser.domain_id);
  let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
  let index: number = _.findIndex(currentCallList, { isCurrent: true });

  if (index !== -1) {
    let eventType: string = currentCallList[index].isGroupCall ? 'Join' : 'SwitchToGroup';
    let framed = frameMultiGroupCall(currentCallList[index].guid, eventType, internalUsers, externalUsers);
    console.log('framed====>>>', framed)
    eventType === 'Join' ? socketservice.groupCallSendEvent(framed.header) : socketservice.switchToGroupCall(framed.header);
  }
  else { toastMessageCallWindow("something went wrong"); }
}

export const removeAllnMuteAll = (type: string, callId: string) => {
  if (type === 'unmuteAll') {
    toastInformation('Future Implementation', 'warning')

  } else {


    let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
    const socketservice = new SocketChatService(loggeduser.sip_login_id, loggeduser.domain_id);
    let removeAll: any = {};
    removeAll.TeamID = callId;
    removeAll.Status = type;

    type === 'RemoveAll' ? socketservice.groupCallSendEvent(removeAll) : socketservice.groupCallMuteStatus(removeAll);
  }

}
export const acceptCall = (data: any) => {

  var ringer: any = document.getElementById("ringercall");
  ringer.pause();
  CallAccept(data.useragent, data.medium, data.fromcaller);
  let guid: any = data.guid;
  store.dispatch({
    type: Types.INCOMING_CALL_POPUP,
    payloads: false,
    callDetail: {}
  });

  let callReducer = store.getState().updatedCallList || [];
  let currentCallList: calldetail[] = callReducer.callDetails || [];
  
  //let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
  let recording: any = store.getState().callPermissionDetail.recordingPermission || [];
  let confInfo: conferenceDetailState = store.getState().conferenceDetails || {};
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];

  if (currentCallList.length !== 0) {
    if (!currentCallList[currentCallList.length - 1].holdState) { holdCall(); }
    currentCallList[currentCallList.length - 1].isCurrent = false;
  }

  let isOnDemand: boolean = recording['ondemand_recording'] || false;
  let isAutomaticRecord: boolean = recording['automatic_recording'] ?
    (recording['automatic_recording'].is_auto_recording && recording['automatic_recording'].inbound) : false;

  let storeData: any = {
    guid,
    useragent: data.useragent,
    from: data.fromcaller,
    to: (loggedUserDetails.ext).toString(),
    muteState: false,
    holdState: false,
    recordState: (isAutomaticRecord),
    onDemand: isOnDemand,
    autoRecord: isAutomaticRecord,
    medium: data.medium,
    bound: "IN",
    contact: data.contact,
    isCurrent: true,
    isNewCall: (confInfo.isConference) ? true : false,
    isGroupCall: data.isGroupCall,
    groupCallInfo: {
      'GroupDetails': {},
      'IndividualDetails': {},
      'PSTNDetails': {}
    },
    isGroupHost: false,
    isHostId: '',
    groupNames: {},
    connectingStatus: 'Connecting...',
    defaultGrpHost: false,
    timer: 0
  };

  currentCallList.push(storeData);
  if (data.isGroupCall) {
    toastInformation('You joined the team call', 'success')
  }
  store.dispatch({
    type: Types.UPDATE_CALL_INFO,
    payloads: {
      callDetails: currentCallList,
      minimizedWindow: (currentCallList.length > 1) ? true : callReducer.minimizedWindow,
      isCallActive: (currentCallList.length === 1) ? true : callReducer.isCallActive,
      isWindowSlide: (currentCallList.length === 1) ? (callReducer.minimizedWindow) ? callReducer.isWindowSlide : true : callReducer.isWindowSlide,
      isCallFullScreen: (currentCallList.length === 1) ? true : callReducer.isCallFullScreen,
      centerWindow: (currentCallList.length === 1) ? (callReducer.minimizedWindow) ? callReducer.centerWindow : 'callWindow' : callReducer.centerWindow,
      rightSideWindow: (currentCallList.length === 1) ? (callReducer.minimizedWindow) ? callReducer.rightSideWindow : 'participantList' : callReducer.rightSideWindow
    }
  });
  if (!storeData.isGroupCall) { setActiveLogs(storeData); }
};

export const setIncomingGroupCall = (incomingDetails: any, isSocketInfo: boolean) => {

  let callReducer = store.getState().updatedCallList || [];
  let currentCallList: calldetail[] = callReducer.callDetails || [];
  if (isSocketInfo) {
    socketInfoMerge(incomingDetails);
  }
  else {
    let inviteBody: string = incomingDetails.useragent.incomingRequest.message.data;
    let str = 'Group-Call:';
    // let strIndex:number= inviteBody.indexOf(str);
    let newone: string = inviteBody.slice(inviteBody.indexOf(str) + str.length);
    let inviteTeamId: string = newone.substring(0, newone.indexOf("iuid"))
    let index: number = currentCallList.findIndex((e: calldetail) => (e.guid.replace(/\D/g, '') === inviteTeamId.replace(/\D/g, '')));
    if (index !== -1) {
      currentCallList[index].useragent = incomingDetails.useragent;
      currentCallList[index].from = incomingDetails.fromcaller;
      currentCallList[index].medium = incomingDetails.medium;
      currentCallList[index].contact = incomingDetails.contact;
    }

    startCallTime(inviteTeamId);
    // if (isAutomaticRecord) { startRecordTimer(inviteTeamId); }

    store.dispatch({
      type: Types.UPDATE_CALL_INFO,
      payloads: {
        callDetails: currentCallList,
        minimizedWindow: false,
        isCallActive: true,
        isWindowSlide: false,
        isCallFullScreen: true,
        centerWindow: (currentCallList.length === 1) ? (callReducer.minimizedWindow) ? callReducer.centerWindow : 'callWindow' : callReducer.centerWindow,
        rightSideWindow: (currentCallList.length === 1) ? (callReducer.minimizedWindow) ? callReducer.rightSideWindow : 'participantList' : callReducer.rightSideWindow
      }
    });
  }
  // if (confInfo.isConference) {
  //   store.dispatch({
  //     type: Types.UPDATDE_CONFERENCE_NEWCALL,
  //     payloads: true
  //   });
  // }
}

const socketInfoMerge = async (incomingDetails: any) => {
  let callReducer = store.getState().updatedCallList || [];
  let currentCallList: calldetail[] = callReducer.callDetails || [];
  let recording: any = store.getState().callPermissionDetail.recordingPermission || [];
  let confInfo: conferenceDetailState = store.getState().conferenceDetails || {};
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  //let incomingCallDetail:any= store.getState().incomingCallWindow||{};
  let isOnDemand: boolean = recording['ondemand_recording'] || false;
  let isAutomaticRecord: boolean = recording['automatic_recording'] ?
    (recording['automatic_recording'].is_auto_recording && recording['automatic_recording'].inbound) : false;
  let groupCallInfo: any = {}
  let storeData: any = {}
  let { groupInfo, TeamID } = incomingDetails || {};
  groupCallInfo.GroupDetails = groupInfo.GroupDetails || {};
  groupCallInfo.IndividualDetails = groupInfo.IndividualDetails || {};
  groupCallInfo.PSTNDetails = groupInfo.PSTNDetails || {};
  // let guid = uuidv4();
  storeData = {
    guid: TeamID,
    useragent: {},
    from: {},
    to: (loggedUserDetails.ext).toString(),
    muteState: false,
    holdState: false,
    recordState: (isAutomaticRecord),
    onDemand: isOnDemand,
    autoRecord: isAutomaticRecord,
    medium: {},
    bound: "IN",
    contact: {},
    isCurrent: true,
    isNewCall: (confInfo.isConference) ? true : false,
    groupCallInfo: groupCallInfo,
    isGroupCall: true,
    isGroupHost: false,
    callStatus: ''
  };


  currentCallList.push(storeData);
  store.dispatch({
    type: Types.UPDATDE_CALL_LIST,
    payloads: currentCallList
  });
}

export const muteGroupCall = () => {
  try {
    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
    let index: number = _.findIndex(currentCallList, { isCurrent: true });
    if (index !== -1) {
      if (!currentCallList[index].muteState) {
        Mute_AudioCall(currentCallList[index].useragent);
        currentCallList[index].muteState = true;
      }
      else {
        currentCallList[index].muteState = false;
        UnMute_AudioCall(currentCallList[index].useragent);
      }
      store.dispatch({
        type: Types.UPDATDE_CALL_LIST,
        payloads: currentCallList
      });
    }
  } catch (error) { console.log("error ", error); }
};
export const sendReInvite = async () => {

  try {


    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
    let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
    for (let index = 0; index < currentCallList.length; index++) {
      let currentDetails = currentCallList[index];
      let contactDetails: any = currentCallList[index].contact;

      var uri = "sip:" + contactDetails.sip_login_id + "@" + loggedUserDetails.domain_name;
      if ((isArray(contactDetails) && contactDetails.length === 0) || !contactDetails?.sip_login_id) {
        uri = "sip:" + currentDetails.to + "@" + loggedUserDetails.domain_name;
      }

      let useragent = currentDetails.useragent;

      if (useragent?.session?.dialogState) {
        let extraHeader = ['Replaces:' + (useragent.session.dialogState.callId) +
          ";to-tag=" + (useragent.session.dialogState.remoteTag) + ";from-tag=" + (useragent.session.dialogState.localTag)]
        if (currentDetails.holdState) {
          extraHeader = ['Replaces:' + (useragent.session.dialogState.callId) +
            ";to-tag=" + (useragent.session.dialogState.remoteTag) + ";from-tag=" + (useragent.session.dialogState.localTag), 'mobilityHoldState:' + (useragent.session.dialogState.localTag)]
        }

        if (currentDetails.isGroupCall) {
          let groupHeader: any = `Group-Call: {"TeamID":"${currentDetails.guid}","Status":"Reconnect"}`;
          extraHeader.push(groupHeader);
        }
        //  let useragentDetails='';
        let UA = store.getState().userAgentDetail.ua;
        let useragentDetails = MakeReInviteCall(
          UA,
          uri,
          'audio',
          contactDetails['caller_id'] || "unknownUser",
          extraHeader

        );


        if (currentDetails.holdState) {
          currentCallList[index].useragent = useragentDetails;
        } else {
          currentCallList[index].useragent = useragentDetails;
        }

        store.dispatch({
          type: Types.UPDATDE_CALL_LIST,
          payloads: currentCallList
        });

        setUpListeners(useragentDetails, currentDetails.to, currentDetails.medium, currentDetails.bound, currentDetails.guid);
      }

    }
  } catch (error) {

    console.log("Reinvite error", error)
  }

}

export const initiateFlipCall = (activeLog: string, medium: string, callId?: string) => {
  try {

    let callReducer = store.getState().updatedCallList || [];
    if (callReducer.callDetails.length < 2) {
      let { activeLogs,filpcallConnected } = store.getState().callReducer || {};
      let currentCallList: calldetail[] = callReducer.callDetails || [];
      let activeCallDetail: any = getCurrentCallDetail();
      let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
      let UA = store.getState().userAgentDetail.ua;
      let {guid,opponentExt,caller_id}:any = activeLog;
     let loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
      let loggedExt: string = (loggedUser.ext)?.toString();
      let flipExt: string = loggedExt === filpcallConnected.from ?filpcallConnected.to : filpcallConnected.from;
      let contact: any = incomingCallDetail(flipExt) || [];
      var uri = "sip:" + guid + "@" + loggedUserDetails.domain_name;

      let flipHeader: any = ["Call-Feature-Type: FLIPCALL"];
      if (currentCallList.length !== 0) {
        if (!currentCallList[currentCallList.length - 1].holdState) { holdCall(); }
        currentCallList[currentCallList.length - 1].isCurrent = false;
      }
      //   let useragent:any;
      let useragent = MakeReInviteCall(
        UA,
        uri,
        medium,
        contact['caller_id'] || "unknownUser",
        flipHeader
      );

      setUpListeners(useragent, opponentExt, medium, "OUT", guid);
      let activeIndex: number = activeLogs.findIndex(
        (ele: any) => ele.guid === guid
      );
      let recording: any = store.getState().callPermissionDetail.recordingPermission || [];
      let isOnDemand: boolean = recording['ondemand_recording'] || false;
      let isAutomaticRecord: boolean =
        recording['automatic_recording'] ? (recording['automatic_recording'].outbound && recording['automatic_recording'].is_auto_recording) : false;


      let data: calldetail = {
        guid,
        useragent: useragent,
        from:(loggedUserDetails['ext']).toString(),
        to:opponentExt,
        muteState: false,
        holdState: false,
        recordState: isAutomaticRecord,
        onDemand: isOnDemand,
        autoRecord: isAutomaticRecord,
        medium: medium,
        bound: "OUT",
        contact,
        isCurrent: true,
        consult: false,
        isNewCall: false,
        isGroupCall: false,
        isGroupHost: true,
        groupCallInfo: {
          'GroupDetails': {},
          'IndividualDetails': {},
          'PSTNDetails': {}
        },
        connectingStatus: 'Connecting...',
        callType: '',
        callStatus: 'Active',
        timer: 0,
        callduration: "00:00:00",
        caller_id:caller_id
      };

      currentCallList.push(data);
      frameCallProfile(data);
      // if (isAutomaticRecord) { startRecordTimer(guid); }
      callInitStore(currentCallList);
      if (!window.location.href.includes('/calls')) { max_Call_Window(); }


      if ((currentCallList.length === 1) ? true : callReducer.isCallActive) {

        if (activeIndex !== -1) {
          activeLogs[activeIndex].callStatus = data.callStatus
          activeLogs[activeIndex].connectingStatus = data.connectingStatus

          storeActiveLogs(activeLogs);

        }
      }
    }
    else {
      toastInformation(`Please merge the calls before making a new call`, 'Warning')
    }

  }
  catch (e: any) { console.log("error is", e); }
}


export const sendVideoCallRequest = (participant: any) => {
  try {
    let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
    let chatWindowReducer: chatwindowDetails = store.getState().chatWindowReducer;

    console.log("chatWindowReducer >>>>>>>", chatWindowReducer);
    let { connectedCallInfo }: any = store.getState().callReducer;
    let meetingDetails: any = {
      participants: "",
      // title:   'Meet now '+  moment(new Date()).format('DD MMM,YYYY HH:mm:ss A'),
      title: `Quick Meeting with ${loggedUserDetails.caller_id.charAt(0).toUpperCase() + loggedUserDetails.caller_id.slice(1)}`,
      meeting_id: getMeetingId(),
      is_host_myaudio: true,
      is_host_myvideo: true,
      is_participant_video: true,
      password: "",
      is_use_personal_meeting_id: false,
      is_participant_waiting_room: false,//videoprofileData?.security.wating_room !== undefined? videoprofileData?.security.wating_room:false,
      personal_meeting_id: getMeetingId()
    }
    let randomId = uuidv4();
    let userInfo = store.getState().loginReducer.userdetails || [];
    let partInfo: any = [{
      email: userInfo.Email,
      ext: userInfo.ext,
      name: userInfo.caller_id,
      profile_img: userInfo.profile_url,
      roletype: 1,
      sipid: (userInfo.sip_login_id)?.toString(),
      user_type: 'company'
    }, {
      email: participant.email_id,
      ext: `${participant.ext}`,
      name: participant.caller_id,
      profile_img: participant.ImageURL,
      roletype: 2,
      sipid: (participant.sip_login_id)?.toString(),
      user_type: 'company'
    }];


    meetingDetails.participants = partInfo;

    meetingDetails['meeting_id'] = randomId;

    console.log("meetingDetails >>>>>>>", meetingDetails);

    let activeCallDetail: any = getCurrentCallDetail();

    console.log("connectedCallInfo >>>>>", connectedCallInfo);
    console.log("activeCallDetail >>>>>>>", activeCallDetail);
    return new Promise((resolve, reject) => {
      new meetingSDK.MeetingRestService().switchtoVideomeetnow(meetingDetails).then((result: any) => {
        console.log("result >>>>>", result);
        if (result?.statusCode === 200) {

          meetingDetails.inviteUrl = result.inviteUrl;
          meetingDetails.uuid = result.uuid;
          meetingDetails.hostName = loggedUserDetails.caller_id;

          let deviceDetails: any = { ...connectedCallInfo }

          if (loggedUserDetails?.ext?.toString() !== connectedCallInfo?.from?.toString()) {
            deviceDetails.fromDeviceType = connectedCallInfo.toDeviceType;
            deviceDetails.from = connectedCallInfo.to;
            deviceDetails.toDeviceType = connectedCallInfo.fromDeviceType;
            deviceDetails.to = connectedCallInfo.from

          }

          console.log("Final deviceDetails >>>>>>", deviceDetails);

          const socketservice = new SocketChatService(loggedUserDetails.sip_login_id, loggedUserDetails.domain_id);

          let data: any = { sipId: `${participant.sip_login_id}`, meetingDetails, deviceDetails }
          console.log("data >>>>>", data);
          socketservice.sendVideoRequest(data);


          store.dispatch({
            type: Types.VIDEO_CALL_REQUEST_SENT,
            payload: {
              isVideoRequestSent: true,
              meetingDetails: meetingDetails
            }
          })
        }
        else {

        }
      })
        .catch((err: any) => {
          console.log("err>>***");

        });
    })

  }
  catch (error) {

  }
};

export const sendVideoCallAccept = (details: any) => {
  try {

    console.log("meetingDetails >>>>>>", details);
    let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
    let activeCallDetail: any = getCurrentCallDetail();
    let { connectedCallInfo }: any = store.getState().callReducer;
    const socketservice = new SocketChatService(loggedUserDetails.sip_login_id, loggedUserDetails.domain_id);

    let sipId = activeCallDetail.contact.sip_login_id

    let deviceDetails: any = { ...connectedCallInfo };
    if (loggedUserDetails?.ext?.toString() !== connectedCallInfo?.from?.toString()) {
      deviceDetails.fromDeviceType = connectedCallInfo.toDeviceType;
      deviceDetails.from = connectedCallInfo.to;
      deviceDetails.toDeviceType = connectedCallInfo.fromDeviceType;
      deviceDetails.to = connectedCallInfo.from

    }

    console.log("connectedCallInfo >>>>>>>", connectedCallInfo);
    console.log("deviceDetails >>>>>>>", deviceDetails);
    let data: any = { sipId: `${sipId}`, meetingDetails: details.meetingDetails, deviceDetails }

    console.log("data >>>>>", data);

    socketservice.videoCallAccept(data);

    store.dispatch({
      type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
      payload: {
        meetingDetails: {},
        isVideocallRingvideo: false
      }
    })

    // currentCallEnd()
    let replaced_url: any = details.meetingDetails.inviteUrl?.includes("stagemeet") ?
      `${details.meetingDetails.inviteUrl}?type=switchtovideo` : `${details.meetingDetails.inviteUrl?.replace('meet.unifiedring', 'meet.worktual')}?type=switchtovideo`;

    window.open(replaced_url, '_blank');


  }
  catch (error) {

  }
};

export const sendCancelVideoCallRequest = (details?: any) => {
  try {

    console.log("sendCancelVideoCallRequest", details);
    let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
    let activeCallDetail: any = getCurrentCallDetail();

    const socketservice = new SocketChatService(loggedUserDetails.sip_login_id, loggedUserDetails.domain_id);

    let { connectedCallInfo }: any = store.getState().callReducer;
    let sipId = activeCallDetail.contact.sip_login_id

    let deviceDetails: any = { ...connectedCallInfo };
    if (loggedUserDetails?.ext?.toString() !== connectedCallInfo?.from?.toString()) {
      deviceDetails.fromDeviceType = connectedCallInfo.toDeviceType;
      deviceDetails.from = connectedCallInfo.to;
      deviceDetails.toDeviceType = connectedCallInfo.fromDeviceType;
      deviceDetails.to = connectedCallInfo.from

    }



    let data: any = { sipId: `${sipId}`, meetingDetails: details, deviceDetails }

    console.log("data >>>>>", data);

    socketservice.videoCallCancel(data);

    store.dispatch({
      type: Types.VIDEO_CALL_REQUEST_SENT,
      payload: {
        isVideoRequestSent: false,
        meetingDetails: {}
      }
    })

    store.dispatch({
      type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
      payload: {
        meetingDetails: {},
        isVideocallRingvideo: false
      }
    })


  }
  catch (error) {

  }
};

export const sendDirectVideoCallAccept = (details: any,param:any) => {
  try {

    console.log("sendDirectVideoCallAccept meetingDetails >>>>>>", details);
    let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];

    const socketservice = new SocketChatService(loggedUserDetails.sip_login_id, loggedUserDetails.domain_id);

    // let participant = _.filter(details.meetingDetails.participants, function (obj: any) { return obj.sipid !== `${loggedUserDetails.sip_login_id}` });
    let participant=_.filter(details.meetingDetails.participants,function(obj:any){return obj.roletype === 1})

    console.log("participant >>>>>>>", participant)

    let sipIdList = _.map(participant, 'sipid');


    let data: any = { sipId: sipIdList, meetingDetails: details.meetingDetails }

    console.log("data >>>>>", data);

    accpectApiVideoInvite(data,param);
    // socketservice.directvideoCallAccept(data);
   

    store.dispatch({
      type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
      payload: {
        meetingDetails: {},
        isVideocallRingvideo: false,
        isDirectVideocall: false
      }
    })

    // currentCallEnd()
    /*   let replaced_url: any = details.meetingDetails.inviteUrl?.includes("stagemeet") ?
      `${details.meetingDetails.inviteUrl}?type=meetnow` : `${details.meetingDetails.inviteUrl?.replace('meet.unifiedring', 'meet.worktual')}?type=meetnow`;
      window.open(replaced_url, '_blank'); */


  }
  catch (error) {

  }
};


// export const sendDirectVideoCallRequest = (participant: any,callType?:any) => {
//   try {
//     let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
//     let meetingDetails: any = {
//       participants: "",
//       // title:   'Meet now '+  moment(new Date()).format('DD MMM,YYYY HH:mm:ss A'),
//       title: `Quick Meeting with ${loggedUserDetails.caller_id.charAt(0).toUpperCase() + loggedUserDetails.caller_id.slice(1)}`,
//       meeting_id: getMeetingId(),
//       is_host_myaudio: true,
//       is_host_myvideo: true,
//       is_participant_video: true,
//       password: "",
//       is_use_personal_meeting_id: false,
//       is_participant_waiting_room: false,//videoprofileData?.security.wating_room !== undefined? videoprofileData?.security.wating_room:false,
//       personal_meeting_id: getMeetingId()
//     }
//     let randomId = uuidv4();
//     let userInfo = store.getState().loginReducer.userdetails || [];
//     let partInfo: any=[] ;
//     let groupSip:any=[];
//     if(callType === "One"){partInfo= [{
//       email: userInfo.Email,
//       ext: userInfo.ext,
//       name: userInfo.caller_id,
//       profile_img: userInfo.profile_url,
//       roletype: 1,
//       sipid: (userInfo.sip_login_id)?.toString(),
//       user_type: 'company'
//     }, {
//       email: participant.email_id,
//       ext: `${participant.ext}`,
//       name: participant.caller_id,
//       profile_img: participant.ImageURL,
//       roletype: 2,
//       sipid: (participant.sip_login_id)?.toString(),
//       user_type: 'company'
//     }];}
//     else{

//       let members:any=Array.isArray(participant.teammembersdetails)&& participant.teammembersdetails.filter((data:any)=>{if(data?.sip_login_id.toString() !== loggedUserDetails?.sip_login_id.toString()) return data})
//       let data:any={};
//       data.email= userInfo.Email;
//       data.ext= userInfo.ext;
//       data.name= userInfo.caller_id;
//       data.profile_img= userInfo.profile_url;
//       data.roletype= 1;
//       data.sipid= (userInfo.sip_login_id)?.toString();
//       data.user_type= 'company';
//       partInfo.push(data);
//       members.forEach((participant:any)=>{
//       partInfo.push({
//             email: participant.email_id,
//             ext: participant.ext,
//             name: participant.caller_id,
//             profile_img: participant.ImageURL,
//             roletype: 2,
//             sipid: (participant.sip_login_id)?.toString(),
//             user_type: 'company'
//       })
//       groupSip.push(participant.sip_login_id.toString());
//         })
    
//     }

//     console.log("parttinfo",partInfo);

//     meetingDetails.participants = partInfo;

//     meetingDetails['meeting_id'] = randomId;

//     console.log("meetingDetails >>>>>>>", meetingDetails);

//     return new Promise((resolve, reject) => {
//       new meetingSDK.MeetingRestService().switchtoVideomeetnow(meetingDetails).then((result: any) => {
//         console.log("result >>>>>", result);
//         if (result?.statusCode === 200) {

//           meetingDetails.inviteUrl = result.inviteUrl;
//           meetingDetails.uuid = result.uuid;
//           meetingDetails.hostName = loggedUserDetails.caller_id;


//           const socketservice = new SocketChatService(loggedUserDetails.sip_login_id, loggedUserDetails.domain_id);
//           let data: any ={}
//           if(callType === "One")
//           {data={ sipId: [`${participant.sip_login_id}`], meetingDetails,isGroupCall:false}
//           console.log("Send video call data >>>>>", data);}
        
//           else {

//             data={sipId:groupSip,meetingDetails,isGroupCall:true}
//             console.log("Send video call data >>>>>", data);}
          
//           socketservice.senddirectVideoRequest(data);

//           store.dispatch({
//             type: Types.VIDEOCALL_RING_STATUS,
//             payload: {
//              ringStatus: true
//             }
//           })

//           store.dispatch({
//             type: Types.VIDEO_CALL_REQUEST_SENT,
//             payload: {
//               isVideoRequestSent: true,
//               meetingDetails: meetingDetails
//             }
//           })

//           store.dispatch({
//             type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
//             payload: {
//               meetingDetails: meetingDetails,
//               isVideocallRingvideo: false,
//               isDirectVideocall: true
//             }
//           })
//         }
//         else {

//         }
//       })
//         .catch((err: any) => {
//           console.log("err>>***");

//         });
//     })

//   }
//   catch (error) {

//   }
// };
export const sendDirectVideoCallRequest = (participant: any) => {
  //one to one video call request
  try {
    let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
    let meetingDetails: any = {
      participants: "",
      // title:   'Meet now '+  moment(new Date()).format('DD MMM,YYYY HH:mm:ss A'),
      title: `Quick Meeting with ${loggedUserDetails.caller_id.charAt(0).toUpperCase() + loggedUserDetails.caller_id.slice(1)}`,
      meeting_id: getMeetingId(),
      is_host_myaudio: true,
      is_host_myvideo: true,
      is_participant_video: true,
      password: "",
      is_use_personal_meeting_id: false,
      is_participant_waiting_room: false,//videoprofileData?.security.wating_room !== undefined? videoprofileData?.security.wating_room:false,
      personal_meeting_id: getMeetingId()
    }
    let randomId = uuidv4();
    let userInfo = store.getState().loginReducer.userdetails || [];
    let partInfo: any = [{
      email: userInfo.Email,
      ext: userInfo.ext,
      name: userInfo.caller_id,
      profile_img: userInfo.profile_url,
      roletype: 1,
      sipid: (userInfo.sip_login_id)?.toString(),
      user_type: 'company'
    }, {
      email: participant.email_id,
      ext: `${participant.ext}`,
      name: participant.caller_id,
      profile_img: participant.ImageURL,
      roletype: 2,
      sipid: (participant.sip_login_id)?.toString(),
      user_type: 'company'
    }];


    meetingDetails.participants = partInfo;

    meetingDetails['meeting_id'] = randomId;

    console.log("meetingDetails >>>>>>>", meetingDetails);

    return new Promise((resolve, reject) => {
      new meetingSDK.MeetingRestService().switchtoVideomeetnow(meetingDetails).then((result: any) => {
        console.log("result >>>>>", result);
        if (result?.statusCode === 200) {

          meetingDetails.inviteUrl = result.inviteUrl;
          meetingDetails.uuid = result.uuid;
          meetingDetails.hostName = loggedUserDetails.caller_id;


          const socketservice = new SocketChatService(loggedUserDetails.sip_login_id, loggedUserDetails.domain_id);
          let data: any ={ sipId: [`${participant.sip_login_id}`], meetingDetails}
          console.log("Send video call data >>>>>", data);
          socketservice.senddirectVideoRequest(data);

          store.dispatch({
            type: Types.VIDEOCALL_RING_STATUS,
            payload: {
             ringStatus: true
            }
          })

          store.dispatch({
            type: Types.VIDEO_CALL_REQUEST_SENT,
            payload: {
              isVideoRequestSent: true,
              meetingDetails: meetingDetails
            }
          })

          store.dispatch({
            type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
            payload: {
              meetingDetails: meetingDetails,
              isVideocallRingvideo: false,
              isDirectVideocall: true
            }
          })
        }
        else {

        }
      })
        .catch((err: any) => {
          console.log("err>>***");

        });
    })

  }
  catch (error) {

  }
};

export const sendHostDirectCancelVideoCallRequest = (details?: any) => {
  //when host cancels the video call request
  try {

    let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];

    const socketservice = new SocketChatService(loggedUserDetails.sip_login_id, loggedUserDetails.domain_id);

let participant = _.filter(details.participants, function (obj: any) { return obj.sipid !== `${loggedUserDetails.sip_login_id}` });
let sipIdList = _.map(participant, 'sipid');

let data: any = { sipId: sipIdList, meetingDetails: details }

accpectApiVideoInvite(data,"");
    // socketservice.directvideoCallCancel(data);

    store.dispatch({
      type: Types.VIDEO_CALL_REQUEST_SENT,
      payload: {
        isVideoRequestSent: false,
        meetingDetails: {}
      }
    })

    store.dispatch({
      type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
      payload: {
        meetingDetails: {},
        isVideocallRingvideo: false,
        isDirectVideocall: false
      }
    })


  }
  catch (error) {
     console.log("eroorrr>>",error)
  }
};

export const videoCallReqNotfy = (type:any,msg?:any) => {
  const {directVmCallCount}:any=store.getState().profileReducer;
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
 if(type ==="accept"){ closeVideoCallRinging();
  store.dispatch({
    type: Types.VIDEO_CALL_REQUEST_SENT,
    payload: {
      isVideoRequestSent: false,
      meetingDetails: {}
    }
  })

  store.dispatch({
    type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
    payload: {
      meetingDetails: {},
      isVideocallRingvideo: false,
      isDirectVideocall: false
    }
  })
  store.dispatch({
    type: Types.VIDEO_CALL_REQ_COUNT,
    payload: {
        directVmCallCount:0
    }
  })}
  else{
   let host_det: any = msg.meetingDetails.participants.find((ele: any) => { return ele.roletype === 1 })
   console.log("host_dettt>>>",host_det,"loggedUserDetails>>",loggedUserDetails);
   if (msg.sipId.includes(host_det.sipid) && msg.sipId.length === 1 && host_det.sipid === loggedUserDetails.sip_login_id){
     if (msg.meetingDetails.participants.length-1 !== directVmCallCount + 1) {
       store.dispatch({
         type: Types.VIDEO_CALL_REQ_COUNT,
         payload: {
             directVmCallCount: directVmCallCount + 1
         }
       })

     }
     else{
      store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_SENT,
        payload: {
          isVideoRequestSent: false,
          meetingDetails: {}
        }
      })
    
      store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
        payload: {
          meetingDetails: {},
          isVideocallRingvideo: false,
          isDirectVideocall: false
        }
      })
      store.dispatch({
        type: Types.VIDEO_CALL_REQ_COUNT,
        payload: {
            directVmCallCount:0
        }
      })
     }
  }
  else{
    store.dispatch({
      type: Types.VIDEO_CALL_REQUEST_SENT,
      payload: {
        isVideoRequestSent: false,
        meetingDetails: {}
      }
    })
  
    store.dispatch({
      type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
      payload: {
        meetingDetails: {},
        isVideocallRingvideo: false,
        isDirectVideocall: false
      }
    }) 
  }
}
}

export const sendDirectCancelVideoCallRequest = (details?: any) => {
  try {

    console.log("sendDirectCancelVideoCallRequest", details);
    let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];

    const socketservice = new SocketChatService(loggedUserDetails.sip_login_id, loggedUserDetails.domain_id);


    let participant = _.filter(details.participants, function (obj: any) { return obj.roletype === 1 });

    console.log("participant >>>>>>>", participant)

    let sipIdList = _.map(participant, 'sipid');

    let data: any = { sipId: sipIdList, meetingDetails: details }

    console.log("data >>>>>", data);
    accpectApiVideoInvite(data,"");
    // socketservice.directvideoCallCancel(data);

    store.dispatch({
      type: Types.VIDEO_CALL_REQUEST_SENT,
      payload: {
        isVideoRequestSent: false,
        meetingDetails: {}
      }
    })

    store.dispatch({
      type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
      payload: {
        meetingDetails: {},
        isVideocallRingvideo: false,
        isDirectVideocall: false
      }
    })


  }
  catch (error) {

  }
};